import controlPaneLocation from './control-pane-location';

export default {
  controlPaneLocation,
};
